import Vue from 'vue';
import { Module } from 'vuex';
import { RootState } from '@/types/store';
import {
    chooseWXPay,
} from '@/lib/script/pay';
import store from '.';
import { isUndef } from '@/lib/utils';
const m: Module<{}, RootState> = {
    actions: {
        /**
         * 下单报名参加赛事
         *
         * @param {} teamId
         * @param {} packageId
         * @param {} referrer 推荐人用户id
         */
        async createOrder({ state, commit }, {
            activityId,
            teamId,
            specialId,
            packageId,
            referrer,
            specifications,
            age,
            gender,
            coin,
            needPay,
            cityId,
            specialTeamId,
            activitySpecialId,
            canChangePackage = true,
            bind_mobile,
            activity_special_id,
            optional_specifications,
            parent_child_avatar,
            deposit,
            order_id,
            orderType,
            deduction_code,
            is_other,
            coupon_id,
            dat,
            qtype
        }) {
            let orderId = order_id;
            console.log('target2232313123', orderId, is_other);
            if(isUndef(order_id)) {
                const data: any = {
                  activity_special_id,
                    bind_mobile,
                    activity_id: activityId,
                    team_id: teamId,
                    package_id: packageId,
                    referrer,
                    specifications,
                    optional_specifications,
                    age,
                    gender,
                    parent_child_avatar,
                    city_id: cityId,
                    special_team_id: specialTeamId,
                    special_id: specialId,
                    can_change_package: canChangePackage ? 1 : 0,
                    deposit,
                    is_other,
                    coupon_id,
                    dat
                };
                if(deduction_code) {
                    data.deduction_code = deduction_code
                }
                if (coin > 0) {
                    data.coin = coin;
                }
                const orderResponse = await Vue.axios.post(
                    qtype
                    ? '/api/v1/offline_activity/order'
                    : '/api/v1/participation/create_order'
                    , data);
                const orderRdata = orderResponse.data;
                if (orderRdata.status !== 0) {
                    return {
                        status: 'error',
                        message: orderRdata.message,
                    };
                }
                orderId = orderRdata.data;
            }
            if (needPay) {
                const payResponse = await Vue.axios.post(
                    qtype
                    ? '/api/v1/offline_activity/order/status'
                    : '/api/v1/participation/pay', {
                    order_id: orderId,
                   type: orderType || 'order',
                });
                const payRdata = payResponse.data;
                if (payRdata.status !== 0) {
                    return {
                        status: 'error',
                        message: payRdata.message,
                    };
                }
                if(payRdata.data.finished) {
                    return {
                        status: 'success',
                        orderId,
                    }
                }

                const ret = await chooseWXPay(payRdata.data.params);
                return {
                    ...ret,
                    type: 'jsapi',
                    orderId,
                };
            } else {
                return {
                    status: 'success',
                    orderId,
                };
            }
        },
        /**
         * 取消订单
         */
        async cancelOrder(context, { orderId }) {
            const response = await Vue.axios.get('/api/v1/participation/cancel_order', {
                params: {
                    id: orderId,
                },
            });
            const rdata = response.data;
            return rdata;
        },
        /**
         * 支付状态检查
         *
         * @param {} orderId 订单号
         * @param {} type  order | upgrade_order
         * @return {} rdata
         */
        async payStatus(context, { orderId, type = 'order' }: { orderId: string, type: string }) {
            const response = await Vue.axios.get('/api/v1/participation/pay_status', {
                params: {
                    id: orderId,
                    type,
                },
            });
            const rdata = response.data;
            return rdata;
        },
        async participationStatus(context, { orderId }: { orderId: string }) {
            const response = await Vue.axios.get('/api/v1/participation/status', {
                params: {
                    order_id: orderId,
                },
            });
            const rdata = response.data;
            return rdata;
        },
    },
};
export default m;
